export default __webpack_public_path__ + "static/media/appStatusComplete.7ed02397.png";